import { createFileRoute } from "@tanstack/react-router";
import { ContentPage } from "@/components/seo/content-page";
import { pickContent } from "@/assets/generated";
import { seoMeta } from "@/lib/seo/head";
import { serviceSchema } from "@/components/seo/json-ld";

export const Route = createFileRoute("/casi-uso/ufficio-legale-aziendale")({
  head: () => seoMeta({
    title: "LexAIPro per uffici legali aziendali",
    description: "Gestione contrattuale, compliance, due diligence e assistenza al business per legali interni in-house counsel.",
    path: "/casi-uso/ufficio-legale-aziendale",
  }),
  component: () => (
    <ContentPage
      extraSchemas={[serviceSchema({ name: "LexAIPro per uffici legali aziendali", description: "AI per in-house counsel: gestione contratti, compliance e due diligence.", path: "/casi-uso/ufficio-legale-aziendale", category: "Legal AI" })]}
      eyebrow="Casi d'uso"
      title="LexAIPro per l'ufficio legale aziendale"
      lead="Per l'in-house counsel: prima revisione automatica dei contratti in entrata, knowledge base interna, supporto al business in tempo reale."
      breadcrumbs={[{name:"Home",path:"/"},{name:"Casi d'uso",path:"/casi-uso/ufficio-legale-aziendale"},{name:"Uffici legali",path:"/casi-uso/ufficio-legale-aziendale"}]}
      sections={[
        { heading: "Casi d'uso aziendali", bullets: ["Revisione contratti fornitori e clienti","Compliance GDPR e 231","Due diligence operazioni straordinarie","Knowledge base legale interna"] },
      ]}
      cta={{ label: "Richiedi una demo", to: "/contatti" }}
      heroImage={pickContent(23)}
      updated="2026"
    />
  ),
});
